<template>
  <div>
    <span>{{ price | formatPrice }}</span>
    <span v-if="isHourly" style="margin-left: 4px; padding: 6px 3px 3px 3px;">H</span>
    <el-tooltip v-if="task.notes" class="item" effect="dark" :content="viewNotesNoHtml" placement="right-end">
      <img class="icon-help m-left-4" src="static/img/icon-info.png" />
    </el-tooltip>
  </div>
</template>

<script>
import { stripHTML } from '@/utilities/utils'
import _ from 'lodash'
import Constants from '@/utilities/constants'

export default {
  props: ['data'],
  data() {
    return {
      isHourly: false
    }
  },
  computed: {
    task() {
      return this.data
    },
    price() {
      let invoicePrice = 0

      if (this.task.job.invoiceBy === Constants.INVOICE_BY.MULTIPLE_TASKS) {
        if (this.task.linkedTasks) {
          invoicePrice = 0
          for (const linkedTask of this.task.linkedTasks) {
            invoicePrice += _.get(linkedTask, 'fieldValues.price')
            // if at least one linked task is hourly, mark the invoice task as hourly
            if (_.get(linkedTask, 'fieldValues.isHourly')) {
              this.isHourly = true
            }
          }
        } else {
          invoicePrice = _.get(this.task, 'fieldValues.price')
          this.isHourly = _.get(this.task, 'fieldValues.isHourly')
        }
      } else {
        // not an invoice submittal task
        invoicePrice = Constants.DO_NOT_DISPLAY_PRICE_VALUE

        // is an invoice submittal task
        if (this.task.name === Constants.TASKS.NAMES.INVOICE_SUBMITTAL) {
          invoicePrice = _.get(this.task, 'fieldValues.price')
          this.isHourly = _.get(this.task, 'fieldValues.isHourly')
        }
      }

      return invoicePrice
    },
    viewNotesNoHtml() {
      return stripHTML(this.task.notes)
    }
  }
}
</script>
